import React from 'react'; 
import { Box, Typography } from '@mui/material';
import Favorite from '@mui/icons-material/Favorite';
import PlaceIcon from '@mui/icons-material/Place';
import { TEXT_DARK_GRAY, ICON_COLOR } from '../colorPalette';
import { numberToIColor } from '../validation/utils';

function GroupHeartItem({heart, group, index}) {
    
    const { hex } = numberToIColor(group.color);

    return (
        <Box>
            <Box sx={{display: 'flex', flexDirection: 'row', marginTop: '5px', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative'}}>
                    <Favorite sx={{fontSize: '60px', fill: hex}} />
                    {/* Status icon */}
                    <Box sx={{backgroundColor: heart.status === 'Online' ? '#03AA00' : '#FF0000', 
                        width: '10px', 
                        height: '10px', 
                        borderRadius: '5px', 
                        border: "1px solid black", position: 'absolute',
                        right: '10px',
                        bottom: '10px'
                    }} />
                </Box>
        
                <Box sx={{textAlign: 'right', alignSelf: 'center', justifyContent: 'space-between', height: '100%'}}>
                    <Typography variant={'body2'} fontWeight={'500'}>{heart.name}</Typography>
                    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '8px'}}>
                        <PlaceIcon sx={{color: '#F06666'}} fontSize={'12px'} />
                        <Typography variant={'body2'} fontSize={'12px'} color={TEXT_DARK_GRAY}>{heart.location}</Typography>
                    </Box>
                </Box>
            </Box>
            {/* Conditionally render underline only if it's not the last item */}
            {index !== group.hearts.length - 1 && (
                <Box sx={{marginTop: '5px', height: '0.3px', width: '80%', alignSelf: 'center', opacity: '40%', backgroundColor: ICON_COLOR}}></Box>
            )}
        </Box>
    )
}

export default GroupHeartItem;